import { tv } from 'tailwind-variants'

import { dataFocusVisibleClasses } from '@/src/styles/classes'

export const cardButtonVariants = tv({
  slots: {
    base: [
      'flex w-full flex-row items-center gap-4 rounded-lg border border-solid p-4',
      'cursor-pointer tap-highlight-transparent outline-none',
      ...dataFocusVisibleClasses,
    ],
    content: 'flex min-w-0 flex-1 flex-col items-start gap-1',
    label: 'w-full',
    description: 'w-full',
    icons: 'shrink-0',
    indicator: 'shrink-0',
  },
  variants: {
    selected: {
      true: {
        // Matches Figma / ChatMessageAuto selected chip: blue-50 fill + blue-300 border.
        base: 'bg-secondary-bg-light border-blue-300',
        // secondary-button-solid-hover maps to palette.blue[700]
        label: 'text-secondary-button-solid-hover',
        description: 'text-secondary-label-light-contrast-low',
        icons: 'text-secondary-label-light-contrast-low',
        indicator: 'text-secondary-label-light-contrast-low',
      },
      false: {
        base: 'bg-default-bg-white border-layout-stroke-contrast-medium',
        label: 'text-default-text-contrast-high',
        description: 'text-default-icon-contrast-lower',
        icons: 'text-default-icon-contrast-lower',
        indicator: 'text-default-icon-contrast-lower',
      },
    },
    disabled: {
      true: {
        base: 'cursor-not-allowed opacity-50',
      },
      false: {},
    },
  },
  defaultVariants: {
    selected: false,
    disabled: false,
  },
})

export type TCardButtonSlots = keyof ReturnType<typeof cardButtonVariants>
